import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { ArrowRight } from '../../../components/Icon';
import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { goToNextState } from '../../../helpers/goToNextState';
import { isFinalState } from '../../../helpers/isFinalState';
import { stateHasValue } from '../../../helpers/stateHasValue';

const StyledButtonsWrpper = styled.div`
  margin: 0;
  text-align: center;
  position: absolute;
  width: 75%;
  left: 50%;
  right: auto;
  z-index: 1;
  top: auto;
  bottom: -5px;
  transform: translate(-50%, -50%);

  @media (min-width: 768px) {
    display: none;
  }

`;

const StyledButton = styled.div<{ disabled?: boolean }>`
  font: normal normal bold 16px/22px Lato;
  letter-spacing: 1.65px;
  height: 49px;
  width: 310px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #1b3155;
  border-radius: 10px;
  background-color: #ffffff;
  text-transform: uppercase;
  padding: 0 2rem;
  max-width: 100%;

  visibility: ${({ disabled }) => {
    return disabled ? `hidden;` : `visible`;
  }};

  svg {
    width: 44px;
    vertical-align: middle;
  }
`;

export const NavigationNextButton = () => {
  const [state, send] = useService(productBuilderMachine);
  return (
    <StyledButtonsWrpper>
      <StyledButton
        onClick={goToNextState(state, send)}
        disabled={
          isFinalState(state) ||
          !stateHasValue(state) ||
          state.matches('measurements.loading') ||
          state.matches('measurements.failure')
        }
      >
        <span>Continue</span>
        <span>
          <ArrowRight />
        </span>
      </StyledButton>
    </StyledButtonsWrpper>
  );
};
